import {
    AncillaryBaggageInfo,
    MealInfo,
    SeatDetail,
    SegmentSeatData,
    SelectedAncillaryType,
    UserSelectedAncillaries,
    UserSelectedAncillaryItem
} from '@/src/types/itinerary'
import { findBaggageByCode } from './baggage'
import { AncillaryDataStructure, createSegmentKey } from './common'
import { findMealByCode } from './meal'
import { findSeatByNumber } from './seat'

// ================================
// SELECTED ANCILLARIES PROCESSING
// ================================

/**
 * Processes selected ancillaries data
 */
export const processSelectedAncillaries = (
    userSelectedAncillaries: UserSelectedAncillaries,
    baggageAncillaries: AncillaryDataStructure<AncillaryBaggageInfo[]>,
    mealAncillaries: AncillaryDataStructure<MealInfo[]>,
    seatAncillaries: AncillaryDataStructure<SegmentSeatData>
): SelectedAncillaryType[] => {
    const selectedAncillaries: SelectedAncillaryType[] = []
    const { userSelectedAncillaryList } = userSelectedAncillaries || {}

    if (!Array.isArray(userSelectedAncillaryList) || userSelectedAncillaryList.length === 0) {
        return selectedAncillaries
    }

    userSelectedAncillaryList.forEach((ancillary: UserSelectedAncillaryItem) => {
        const { baggageDetails, mealDetails, seatDetails, segmentOriginDestinationInfo } = ancillary || {}

        if (!segmentOriginDestinationInfo?.from || !segmentOriginDestinationInfo?.to) {
            return
        }

        const segmentKey = createSegmentKey(segmentOriginDestinationInfo.from, segmentOriginDestinationInfo.to)

        const selectedAncillary: SelectedAncillaryType = {
            segmentOriginDestinationInfo,
            baggageDetails: [],
            mealDetails: [],
            seatDetails: []
        }

        // Process baggage details - find full baggage objects
        if (Array.isArray(baggageDetails) && baggageDetails.length > 0) {
            selectedAncillary.baggageDetails = baggageDetails
                .map(baggage => {
                    if (baggage.baggageCode) {
                        return findBaggageByCode(baggage.baggageCode, segmentKey, baggageAncillaries)
                    }
                })
                .filter(Boolean) as AncillaryBaggageInfo[]
        }

        // Process meal details - find full meal objects
        if (Array.isArray(mealDetails) && mealDetails.length > 0) {
            selectedAncillary.mealDetails = mealDetails
                .map(meal => {
                    if (meal.mealCode) {
                        return findMealByCode(meal.mealCode, segmentKey, mealAncillaries)
                    }
                })
                .filter(Boolean) as MealInfo[]
        }

        // Process seat details - find full seat objects
        if (Array.isArray(seatDetails) && seatDetails.length > 0) {
            selectedAncillary.seatDetails = seatDetails
                .map(seat => {
                    const seatNumber = seat.rowId + seat.columnId
                    return findSeatByNumber(seatNumber, segmentKey, seatAncillaries)
                })
                .filter(Boolean) as SeatDetail[]
        }

        selectedAncillaries.push(selectedAncillary)
    })

    return selectedAncillaries
}
